import React from 'react';
import { TimelineEvent } from 'react-event-timeline';
import Icon from '@amzn/meridian/icon';
import chatTokens from '@amzn/meridian-tokens/base/icon/chat';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { decode } from 'html-entities';

import {
  ContactTimelineEvent,
  EventType,
} from '../../../api/ContactListening/schema';

export interface ContactTimelineEventProps {
  contactTimelineEvent: ContactTimelineEvent;
}

export const ContactTimelineEventBox: React.FC<ContactTimelineEventProps> = ({
  contactTimelineEvent,
}: ContactTimelineEventProps): React.ReactElement => {
  const contactTimlineBoxStyle = { marginBottom: '10px' }; // Declare the style here
  const translatedMessage = contactTimelineEvent.translatedMessage;
  let translatedMessageValues;
  try {
    if (translatedMessage) {
      const msg = JSON.parse(contactTimelineEvent.message);
      translatedMessageValues =
        msg && msg.hashGetParams
          ? msg.hashGetParams
          : contactTimelineEvent.message;
      translatedMessageValues['hasTicketId'] = translatedMessageValues.ticketId
        ? 'true'
        : 'false';
    }
  } catch (error) {
    translatedMessageValues = contactTimelineEvent.message;
  }

  return (
    <TimelineEvent
      title={
        <div style={{ fontSize: '14px', marginBottom: '5px' }}>
          {moment(contactTimelineEvent.date).format('LLLL')}
          <br />
          <div>
            <span style={{ fontWeight: 500 }}>
              {translatedMessage ? (
                <FormattedMessage
                  id={translatedMessage.stringId}
                  defaultMessage={decode(contactTimelineEvent.message)}
                  values={translatedMessageValues}
                />
              ) : contactTimelineEvent.eventType ===
                EventType.STATE_TRANSITION ? (
                <>
                  <FormattedMessage
                    id={contactTimelineEvent.message.split(' ')[0]}
                    defaultMessage={contactTimelineEvent.message.split(' ')[0]}
                  />
                  {contactTimelineEvent.message.split(' ').length > 1 &&
                    ` ${contactTimelineEvent.message.split(' ')[1]}`}
                </>
              ) : (
                decode(contactTimelineEvent.message) || ''
              )}
            </span>
          </div>
        </div>
      }
      subtitle={
        <span style={{ fontSize: '1.3em' }}>
          {contactTimelineEvent.agent?.agentLogin &&
            `Agent: ${contactTimelineEvent.agent.agentLogin}`}
          <br />
          {contactTimelineEvent.agent?.agentOwner &&
            `Owner: ${contactTimelineEvent.agent.agentOwner}`}
        </span>
      }
      icon={
        contactTimelineEvent.eventType === 'STATE_TRANSITION' ? (
          <Icon tokens={infoKnockoutTokens} />
        ) : (
          <Icon tokens={chatTokens} />
        )
      }
      iconColor={'#232f3e'}
      iconStyle={{
        cursor: 'auto',
      }}
      style={contactTimlineBoxStyle}
    />
  );
};

export default ContactTimelineEventBox;
